import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import TopNavigation from '../../TopNavigation'
import withAppconfig from '../../AppContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import ProShopProductCard from '../../components/Shop/ProShopProductCard'
import { Typography, MenuItem, MenuList, ListItemText } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const mapStateToProps = (state, props) => {
  const { firebase } = state
  const { proshopproducts, proshopcategories, proshopbrands } = firebase.ordered
  const products = proshopproducts ? proshopproducts.map((m) => { 
    const category = proshopcategories ? proshopcategories.find((c) => c.key === m.value.productcategory) : null
    const brand = proshopbrands ? proshopbrands.find((b) => b.key === m.value.brand) : null
    const poster = m.value.image ? m.value.image : (props.appconfig && props.appconfig.logos && props.appconfig.logos.length > 0 ? { url: props.appconfig.logos[0].value, sizes: [300] } : null)
    const p = { id: m.key, ...m.value, categoryname: category ? category.value.displayName : null, brandname: brand ? brand.value.displayName : null }
    if (poster) p.poster = poster
    return p
  }) : []
  // return only categories which have products
  const categoriesWithProducts = proshopcategories ? proshopcategories.filter((c) => proshopproducts.find((p) => p.value.productcategory === c.key)) : []
  return {
    products,
    categories: categoriesWithProducts ? categoriesWithProducts.map((m) => { return { id: m.key, ...m.value } }) : [],
    brands: proshopbrands ? proshopbrands.map((m) => { return { id: m.key, ...m.value } }) : []
  }
}

const withProducts = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firebaseConnect((props) => [
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/products',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopproducts',
    },
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/categories',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopcategories',
    },
    {
      path: 'shop/' + props.appconfig.accountkey + '/proshop/brands',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'proshopbrands',
    }
  ]),
  connect(mapStateToProps)
)

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory, numberofproducts }) => {
  const showAll = numberofproducts < 20
  if (!showAll && !selectedCategory && categories && categories.length > 0) {
    onSelectCategory(categories[0].id)
  } 
  return (
    <MenuList style={{ display: 'flex', flexDirection: 'row', paddingLeft: 0 }}>
      {showAll &&
        <MenuItem onClick={() => onSelectCategory(null)} selected={selectedCategory === null}>
          <ListItemText primary={'Kaikki'} />
        </MenuItem>
      }
      {categories.map((c, i) => (
        <MenuItem key={c.id} onClick={() => onSelectCategory(c.id)} selected={selectedCategory === c.id}>
          <ListItemText primary={c.displayName} />
        </MenuItem>
      ))}
    </MenuList>
  )
}

function ProshopScreen({ appconfig, products, categories, brands }) {
  const { t } = useTranslation()
  const hasProducts = products && products.length > 0
  const [selectedCategory, setSelectedCategory] = React.useState(null)
  const [selectedProduct, setSelectedProduct] = React.useState(null)
  const [sessionCart, setSessionCart] = React.useState([])


  const addToCart = (product) => {
    setSessionCart([...sessionCart, product])
  }

  if (!hasProducts) {
    return (
      <div className='full-page-background'>
        <TopNavigation />
        <Container className='front' style={{ paddingTop: 10 }}>
          <Typography variant='h6' style={{ paddingBottom: 20 }}>
            {t('products')} (0)
          </Typography>
          <Typography variant='body1'>{t('noproducts')}</Typography>
        </Container>
      </div>
    )
  }

  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
    <Row>
      <Col>
        <CategoryFilter
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
          numberofproducts={products && products.length ? products.length : 0}
          />
          </Col>
          <Col>
          {/* Cart here */}
            {sessionCart.length > 0 ? (
              <Typography variant='body1'>
                {t('cart')}: {sessionCart.length} {t('items')}
              </Typography>) : null}
          </Col>
          </Row>
        <Row>
          {selectedProduct ? (
            <Col xs={12}>
              <ProShopProductCard
                product={selectedProduct}
                collection={'proshop/products'}
                isAuthRequired={false}
                onSelected={setSelectedProduct}
                selected={true}
                onCart={addToCart}
              />
            </Col>
          ) : null}
            {!selectedProduct && products.filter((m) => !selectedCategory || m.productcategory === selectedCategory).map((m) => (
              <Col key={m.id} xs={12} sm={4}>
                <ProShopProductCard
                  product={m}
                  collection={'proshop/products'}
                  isAuthRequired={false}
                  onSelected={setSelectedProduct}
                  selected={selectedProduct && selectedProduct.id === m.id}
                />
              </Col>
            ))}
          </Row>
      </Container>
    </div>
  )
}

export default withAppconfig(withProducts(ProshopScreen))
